import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "d-flex justify-content-center" }
const _hoisted_5 = { class: "form-field-floating full my-5" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-field-floating full my-5" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "text-red"
}
const _hoisted_10 = { class: "flex gap-2" }

import { inject, onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketSettingsView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        banners: [] as any, 
        top_categories: [],
        top_produits: [],
    });
    const errors = reactive({
        banners: "",
        top_categories: "",
        top_produits: "",
    });
    const startupFormDatas = reactive({
        categories: [] as any[],
        produits: [] as any[],
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        Object.assign(startupFormDatas, {
            categories: form_datas.categories,
            produits: form_datas.produits,
        });
        if (form_datas?.settings) {
            const item = form_datas.settings as any;
            if (item.banners) {
                Object.keys(item.banners).forEach((banniereKey) => {
                    if (item.banners[banniereKey]) {
                        formData.banners[banniereKey] = {
                            file_preview: BACKEND_URL + '/assets/market_banners/300/' + item.banners[banniereKey],
                            file: null,
                        };
                    }
                });
            }
            console.log(formData.banners);
            formData.top_categories = item.top_categories || [];
            formData.top_produits = item.top_produits || [];
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;
        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            formData.banners.forEach((banniere: any, banniereId: string) => {
                if (banniere.file) {
                    formToUpload.append(`banners[${banniereId}]`, banniere.file, banniere.name);
                } else {
                    formToUpload.append(`banners[${banniereId}]`, '');
                }
            });
            formData.top_categories.forEach((categorieId: string, index: number) => {
                formToUpload.append(`top_categories[${index}]`, categorieId);
            });
            formData.top_produits.forEach((produitId: string, index: number) => {
                formToUpload.append(`top_produits[${index}]`, produitId);
            });
            
            await axios.post(`/backoffice/market-settings/save`, formToUpload);
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onFileBanniereUploaded(index: number, uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.banners[index] = { file: uploadedFile.file, name: uploadedFile.file_name };
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_bloc_file_input = _resolveComponent("custom-bloc-file-input")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Paramètres Market "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "item-row d-flex mb-3" }, [
          _createElementVNode("div", { class: "label f-s-14" }, "Bannières :")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_custom_bloc_file_input, {
            title: "Bannière 1",
            id: "banniere_1",
            onUploaded: _cache[0] || (_cache[0] = ($event: any) => (onFileBanniereUploaded(0, $event))),
            preview: formData.banners[0]?.file_preview
          }, null, 8, ["preview"]),
          _createVNode(_component_custom_bloc_file_input, {
            title: "Bannière 2",
            id: "banniere_2",
            onUploaded: _cache[1] || (_cache[1] = ($event: any) => (onFileBanniereUploaded(1, $event))),
            preview: formData.banners[1]?.file_preview
          }, null, 8, ["preview"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.top_categories) = $event)),
            name: "top_categories",
            id: "top_categories",
            multiple: "true",
            size: "1"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.categories, (categorie, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: categorie.id,
                key: 'categorie_' + index
              }, _toDisplayString(categorie.nom), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.top_categories]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "top_categories" }, "Top Catégories", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.top_produits) = $event)),
            name: "top_produits",
            id: "top_produits",
            multiple: "true",
            size: "1"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.produits, (produit, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: produit.id,
                key: 'produit_' + index
              }, _toDisplayString(produit.nom), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.top_produits]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "top_produits" }, "Top Produits", -1))
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})